import React, { ComponentType, ReactElement, Suspense } from 'react';
import { CenteredSpinner } from '../../../components';

const Diagram = React.lazy(
  () =>
    import('./container.tsx') as unknown as Promise<{ default: ComponentType }>,
);

export function CodeSplittedDiagram(): ReactElement {
  return (
    <div>
      <Suspense fallback={<CenteredSpinner size="small" />}>
        <Diagram />
      </Suspense>
    </div>
  );
}
